import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Table, Col, Row, Label, Spinner } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { withNamespaces } from 'react-i18next';
import showNotification from '../helpers/show_notification';


const BatchWithDrawCorrectionModal = ({
  isOpen,
  toggle,
  onSubmit,
  item,
  isLoading,
  closure,
  t 
}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedItem, setSelectedItem] = useState({})

  useEffect(() => {
    setSelectedItem(item)
  }, [item])

  const handleQuantityUpdate = (index, quantity, newunit) => {
    setSelectedItem(prevSelectedItems => {
      // const updatedUnits = prevSelectedItems.quantity.map((unit, i) =>
      //   newunit === unit.unit ? { ...unit, value: quantity } : i === index ? { ...unit, value: quantity } : unit
      //  );
      // return { ...prevSelectedItems, quantity: updatedUnits };
      return {
        ...prevSelectedItems,
        quantity: prevSelectedItems.quantity.map((u) => u.unit === newunit ? { ...u, value: quantity } : u)
      }
    });
  };

  const handleCheckboxUpdate = (index, unitObj, setSelectedItem) => {
    setSelectedItem((prev) => {
      const updatedQuantity = [...prev.quantity];
      const existingUnitIndex = updatedQuantity.findIndex(
        (unit) => unit.unit === unitObj.unit
      );

      // Check for last checked unit
      if (existingUnitIndex !== -1 && !closure &&
        updatedQuantity[existingUnitIndex].isChecked &&
        updatedQuantity.filter(unit => unit.isChecked).length === 1) {
        showNotification("You must have at least one unit checked.", "Warning");
        return prev;
      }

      if (existingUnitIndex === -1) {
        updatedQuantity.push({
          unit: unitObj.unit,
          // formula: unitObj.value,
          value: 0,
          index,
          isChecked: true,
        });
      } else {
        if (updatedQuantity[existingUnitIndex].isChecked ) {
          updatedQuantity.splice(existingUnitIndex, 1);
        } else {
          updatedQuantity[existingUnitIndex].isChecked = true;
        }
      }
      // console.log(updatedQuantity,"before");
      updatedQuantity.sort((a, b) => {
        const unitA = prev?.unit_levels.find(u => u.unit === a.unit);
        const unitB = prev?.unit_levels.find(u => u.unit === b.unit);
        return unitA.value - unitB.value;
      });
      // console.log(updatedQuantity,"after");

      return { ...prev, quantity: updatedQuantity };
    });
  };
  const handleSubmit =async () => {
       let res = await onSubmit(selectedItem.quantity);       
        if(res){
            setSelectedItem([]);
              toggle();
        }
  };

  function Modaltoggle (){
    setSelectedItem([])
      toggle()
  }
  return (
    <Modal isOpen={isOpen} toggle={Modaltoggle} size="md">
      <ModalHeader toggle={Modaltoggle}>
        {`${t("Update Quantity")}`}
      </ModalHeader>
      <ModalBody>
       <AvForm onValidSubmit={handleSubmit}>
                <Col lg={12}>
                  <Table bordered size="sm" responsive className="table table-sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{t("Unit")}</th>
                        <th>{t("Quantity")}</th>
                        <th>{t("formula")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedItem &&
                        selectedItem.unit_levels?.map((unitObj, index) => {
                          let prevUnit;
                          if (index == 0) {
                            prevUnit = "NA";
                          } else
                            prevUnit =
                              selectedItem?.unit_levels[index - 1].unit;
                          const selectedUnit = selectedItem?.quantity?.find(
                            (su) => su.unit === unitObj.unit
                          );
                          return (
                            <tr key={index}>
                              <td>
                                <div class="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    checked={selectedUnit?.isChecked}
                                    onChange={() =>
                                      handleCheckboxUpdate(index, unitObj, setSelectedItem)
                                    }
                                  />
                                </div>
                              </td>
                              <td onClick={() => handleCheckboxUpdate(index, unitObj, setSelectedItem)}>
                                {unitObj.unit}
                              </td>
                              <td>
                                <AvField
                                  type="number"
                                  placeholder=""
                                  className="form-control"
                                  disabled={selectedUnit?.isChecked ? false : true}
                                  style={{ width: "60px", height: "20px" }}
                                  name={unitObj.unit}
                                  value={selectedUnit ? selectedUnit.value.toString() : ''}
                                  validate={{
                                    required: { value: selectedUnit?.isChecked ? true : false },
                                    min: { value: 0, errorMessage: 'can not be zero' },
                                    pattern: { value: "^[0-9]+$", errorMessage: "No decimal values allowed" }, 
                                  }}
                                  errorMessage={t("Qty. can't be empty")}
                                  onChange={(e) => {
                                    const quantity = e.target.value;
                                    handleQuantityUpdate(index, Number(quantity), unitObj.unit);
                                  }}
                                />
                              </td>
                              <td>
                                {index > 0
                                  ? "1" + "  " + prevUnit + " = " + unitObj.value + " " + unitObj.unit
                                  : "NA"}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </Col>
      
                <Row className="mt-3">
                  <Col lg={12}>
                    <div className="text-center">
                      <Button type="submit" color="primary" style={{width:"120px"}} disabled={isLoading}>
                        {isLoading ? <Spinner  size={"sm"}/> :  t("Update")}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </AvForm>
      </ModalBody>
    </Modal>
  );
};

export default withNamespaces()(BatchWithDrawCorrectionModal);